import { supabase } from '../supabaseClient';
import { PLATFORM_TEST_ACCOUNT_EMAIL } from '../types/billingSettings';

export { PLATFORM_TEST_ACCOUNT_EMAIL };

export type AdminTestAccountResult = {
  ok: boolean;
  created?: boolean;
  email?: string;
  /** 생성·재발급 시에만 — 서버가 만든 새 비밀번호(한 번만 표시) */
  password?: string;
  uid?: string | null;
  plan_tier?: string;
  pass_epoch?: number;
  error?: string;
  message?: string;
};

export async function createPlatformTestAccount(): Promise<AdminTestAccountResult> {
  const { data, error } = await supabase.functions.invoke('admin-create-test-account', {
    body: {},
  });
  if (error) {
    return { ok: false, error: error.message || '테스트 계정 생성에 실패했습니다.' };
  }
  const body = (data ?? {}) as AdminTestAccountResult;
  if (!body.ok) {
    return {
      ok: false,
      error: body.message || body.error || '테스트 계정 생성에 실패했습니다.',
    };
  }
  return body;
}

export async function resetPlatformTestAccount(): Promise<AdminTestAccountResult> {
  const { data, error } = await supabase.functions.invoke('admin-reset-test-account', {
    body: {},
  });
  if (error) {
    return { ok: false, error: error.message || '테스트 계정 초기화에 실패했습니다.' };
  }
  const body = (data ?? {}) as AdminTestAccountResult;
  if (!body.ok) {
    return {
      ok: false,
      error: body.message || body.error || '테스트 계정 초기화에 실패했습니다.',
    };
  }
  return body;
}
